export const SbpIcon = () => {
  return (
    <svg
      width="56"
      height="32"
      viewBox="0 0 56 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.5551 12.4732V20.2966H52.7615V14.8087H50.0717V20.2966H47.2781V12.4727H55.5551V12.4732Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5408 20.5772C44.0416 20.5772 45.8986 19.0438 45.8986 16.7193C45.8986 14.4695 44.5285 13.0087 42.2386 13.0087C41.1818 13.0087 40.3098 13.3807 39.653 14.0225C39.8098 12.6959 40.9317 11.7273 42.1669 11.7273C42.452 11.7273 44.5981 11.7228 44.5981 11.7228L45.8117 9.40039C45.8117 9.40039 43.1173 9.46172 41.8648 9.46172C39.0029 9.51159 37.0698 12.1129 37.0698 15.2724C37.0698 18.9532 38.9552 20.5772 41.5408 20.5772ZM41.556 15.0657C42.4845 15.0657 43.1282 15.6759 43.1282 16.7191C43.1282 17.658 42.5562 18.4316 41.556 18.4337C40.5992 18.4337 39.9554 17.7169 39.9554 16.7351C39.9554 15.6916 40.5992 15.0657 41.556 15.0657Z"
        fill="white"
      />
      <path
        d="M34.7959 17.6773C34.7959 17.6773 34.1362 18.0576 33.1509 18.1296C32.0181 18.1632 31.0087 17.4477 31.0087 16.1765C31.0087 14.9365 31.8994 14.2259 33.1223 14.2259C33.8722 14.2259 34.8642 14.7456 34.8642 14.7456C34.8642 14.7456 35.5901 13.4136 35.9661 12.7475C35.2775 12.2256 34.3605 11.9395 33.2938 11.9395C30.6018 11.9395 28.5167 13.6947 28.5167 16.1608C28.5167 18.6584 30.4765 20.3728 33.2938 20.321C34.0813 20.2917 35.1677 20.0152 35.8298 19.5898L34.7959 17.6773Z"
        fill="white"
      />
      <path
        d="M0.444702 6.96484L4.3199 13.8915V18.1166L0.449235 25.0296L0.444702 6.96484Z"
        fill="#5B57A2"
      />
      <path
        d="M15.3239 11.3712L18.9551 9.14561L26.3866 9.13867L15.3239 15.9157V11.3712Z"
        fill="#D90751"
      />
      <path
        d="M15.3034 6.92453L15.3239 16.0952L11.4396 13.7085V0L15.3034 6.92453Z"
        fill="#FAB718"
      />
      <path
        d="M26.3866 9.13892L18.9548 9.14586L15.3034 6.92453L11.4396 0L26.3866 9.13892Z"
        fill="#ED6F26"
      />
      <path
        d="M15.3239 25.068V20.6187L11.4396 18.2773L11.4418 31.9995L15.3239 25.068Z"
        fill="#63B22F"
      />
      <path
        d="M18.946 22.8627L4.31963 13.8915L0.444702 6.96484L26.3708 22.8536L18.946 22.8627Z"
        fill="#1487C9"
      />
      <path
        d="M11.442 31.9994L15.3236 25.0679L18.9457 22.8626L26.3705 22.8535L11.442 31.9994Z"
        fill="#017F36"
      />
      <path
        d="M0.44928 25.0295L11.4714 18.2775L7.76581 16.0039L4.31994 18.1164L0.44928 25.0295Z"
        fill="#984995"
      />
    </svg>
  );
};
